module.exports = {
  "en-US": "English",
  es: "Español",
  fr: "Francés",
  ht: "Kreyol",
  switch_es: "En español",
  "switch_en-US": "In english",
  switch_fr: "En français",
  switch_ht: "Nan kreyol",
  back: "Retounen",
  continue: "Kontinye",
  step: "Etap",
  yes: "Wi",
  no: "Nom",
  nonpay: "Pa peye kay (Nonpayment)",
  holdover: "Yo Mande Kay",
  general: "Mwen pa sèten",
  other: "Yon lot bagay",
  submit: "Soumèt",
  gotit: "Ou konpran",
  addrPlaceholder: "Mete adrès ou",
  nychaPlaceholder: "Seleksyone devlopman ou abite ya",
  addrError: "Nou regrèt! Nou pa jwenn adrès ou. Eseye ankò.",
  zipTitle: "“Zip code” ou",
  householdSize: "Kantite mounn ki nan kay la",
  income: "Kantite lajan ou touche",
  qualifiedTitle: "Bon nouvèl! Ou kalifye pou reprezantasyon legal gratis.",
  notQualifiedTitle:
    "Ou gen dwa pa kalifye pou yon avoka gratis, men ou ka toujou jwenn asistans!",
  doNow: "Men kisa ou dwe fè kounye a:",
  additionalResources: "Lot Enfomasyon:",
  attribution:
    'Enfòmasyon sa se “lokatè ki mete li pou lokatè” men se <a href="https://www.righttocounselnyc.org/" target="_blank"> Right to Counsel NYC Coalition</a> ki konsève sit entènèt la. <br /><br /><a href="https://docs.google.com/forms/d/e/1FAIpQLSfovU5BDMZHaX-EKQmSyVyKdrPvp9y0VuIBx_NlMQHB0NkNng/viewform?usp=sf_link" target="_blank">Klike la</a> a pou bay kòmantè sou sit entènèt la.',
  justfixAttribution: "Fè avèk NYC ♥ Avèk ekip @",
  print: "Imprime",
  getInvolvedTitle: "Angaje w nan mouvman “Right to Counsel”!",
  shareTitle: "Separe paj la avèk vwazen ou:",
  email: "Imèl",
  registrationTitle: "Resevwa enfomasyon resan nan email:",
  registrationBtn: "Anregistre avèk email",
  eventsTitle: "Patisipe nan evenman kap vini yo",
  eventsBtn: "Jwen evenman",
  saveToPhoneTitle: "Konsève paj sa nan telefonn ou",
  saveToPhoneSubtitle:
    "Rantre nimewo telefonn ou epi nap voye yon mesaj ba ou ak yon ”link” pou konsève paj sa.",
  saveToPhoneInfo:
    "Nimewo wa sipoze komanse pa +1. <br>Nou pap jan konsève nimewo telefonn ou oubyen itilize li an deyo mesaj sa.</brb>",
  success: "Siksè",
  tryAgain: "Eseye anko",
  connectLSP: "Konekte avek yon avoka avan randevou tribinal la:",
  next: "Swivan",
  more: "Wè plis",
  prev: "Anvan",
  website: "Sit entènèt",
  evictionFreeNYC: "Yon NYC San Degèpisman!",
  textMessageContent: "Swiv “link” sa pou aistans pou ka degèpisman ou an",
  groupsTitle: "Konekte Ak Yon òganizasyon ki nan zònn ou!",
  groupsLookMore:
    "Ou bezwen plis enfòmasyon? Chache nan Lis Oganizasyon Pou Lokatè Yo.",
  groupsEmpty:
    "Pa gen ankenn òganizasyon lokatè ki ap travay kounye a nan zònn ou an.",
  groupsEmptySubtitle:
    "Chèche nan lis asosyasyon lokatè yo pou ka jwenn lòt asistans.",
  groupsSearch: "Rantre “zip code” ou pou yon jwen òganizasyon ki nan zònn ou!",
  titleOverride:
    "Si'w gen pou ale nan yon jijman administratif (administrative hearing) nan NYCHA epi si moun ki tèt kay la nan apatman'w lan gen 62 zan oubyen plis ke 62 zan, ou gen dwa genyen yon avoka.  Otreman, menm si ou pa kalifye, ou ka toujou jwenn èd.",
};



// WEBPACK FOOTER //
// ./src/data/messages/ht.js